// Lucide icon: eye (https://lucide.dev/icons/eye)
import { Eye } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconShow = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Eye />
    </IconComponentStyled>
  )
}
